<template>
  <div class="flex justify-end items-end gap-4 flex-shrink-0">
    <Button
      class="bg-primary-900 text-white h-10 py-2 px-4 rounded-lg text-xs hover:bg-primary-500"
      :disabled="loading || !isValid"
      @click="handleGet"
      :loading="loading"
      :label="$t('reports.filters.get')"
    />
    <Button
      v-if="!hideExport"
      class="bg-orange-red text-white h-10 py-2 px-4 rounded-lg text-xs"
      :disabled="loadingExport || !isValid"
      :loading="loadingExport"
      @click="handleExport"
    >
      <v-icon class="text-white" v-if="enableBtns">mdi-file-document-outline</v-icon>
      {{ $t("reports.filters.export") }}
    </Button>
  </div>
</template>

<script>
import { Button } from 'primevue';

export default {
  name: 'FilterActions',
  components: {
    Button
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    loadingExport: {
      type: Boolean,
      default: false
    },
    isValid: {
      type: Boolean,
      default: true
    },
    hideExport: {
      type: Boolean,
      default: false
    },
    enableBtns: {
      type: Boolean,
      default: true
    }
  },
  emits: ['get', 'export'],
  methods: {
    handleGet() {
      this.$emit('get');
    },
    handleExport() {
      this.$emit('export');
    }
  }
};
</script> 